import React from "react";
import { motion } from "framer-motion";
import { clients } from "../Data";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const Clients = () => {
  return (
    <section className="clients-section container">

      {/* HEADING */}
      <motion.h3
        className="section-subheading"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        OUR VALUABLE CLIENTS
      </motion.h3>

      <motion.h2
        className="section-heading"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.15,
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{ once: true }}
      >
        A Trusted Partner to Global Enterprises
      </motion.h2>

      {/* SLIDER */}
      <motion.div
        className="clients-slider"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >

        <Swiper
          modules={[Autoplay]}
          spaceBetween={18}
          slidesPerView={4}
          loop={true}
          speed={2500}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },

            576: {
              slidesPerView: 1,
            },

            768: {
              slidesPerView: 2,
            },

            992: {
              slidesPerView: 4,
            },
          }}
        >

          {clients.map((item, i) => (

            <SwiperSlide key={i}>

              <motion.div
                className="clients-card"
                whileHover={{
                  y: -6,
                  scale: 1.04,
                }}
              >

                <motion.img
                  src={item.image}
                  alt={`Client Logo ${i + 1} | Gurukrupa Wood Pvt. Ltd.`}
                  whileHover={{
                    scale: 1.08,
                  }}
                  transition={{ duration: 0.3 }}
                />

              </motion.div>

            </SwiperSlide>

          ))}

        </Swiper>

      </motion.div>

    </section>
  );
};

export default Clients;